<footer>
  <!-- Copyright -->
  <div class="text-center p-4">
      © {{fullYear}}
      <a class="text-reset fw-bold" href="http://energizeglobalservices.com/">Energize Global Services</a>
  </div>
  <!-- Copyright -->
</footer>
